import { createContext } from 'react';

type TailwindCssContextType = {
    tailwindCssLoaded: boolean;
    loadTailwind: () => Promise<boolean>;
};

// No need for undefined here!
const TailwindCssContext = createContext<TailwindCssContextType>(null!);

export default TailwindCssContext;